export const templateAcai = {

config:{
cor_primaria:"#4a235a"
},

elementos:[

{
id:1,
tipo:"texto",
conteudo:"AÇAÍ POWER",
pos_x:80,
pos_y:40,
estilo:{fontSize:32,color:"#fff"}
},

{
id:2,
tipo:"texto",
conteudo:"300ML",
pos_x:30,
pos_y:180,
estilo:{fontSize:16,color:"#fff"}
},

{
id:3,
tipo:"texto",
conteudo:"R$ 12",
pos_x:260,
pos_y:180,
estilo:{fontSize:16,color:"#fff"}
}

]

};